export const HomeArrowIcon = ({color="#140D0B", size = 14}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path className="svg-icon" fillRule="evenodd" clipRule="evenodd"
            d="M13.4722 12.6695V1.35901V0.955078H13.0683H1.75806L1.75806 1.76295H12.0935L1.47266 12.3838L2.04391 12.9551L12.6643 2.33463V12.6695H13.4722Z"
            fill={color} stroke={color}/>
    </svg>
  )
}